import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface chatSliceType {
  chatMessages: any;
  agentType: string;
  isAiResponding: boolean 
}

const initialCodeSliceObject: chatSliceType = {
  chatMessages: [],
  agentType: "",
  isAiResponding: false, 
};

const chatSlice = createSlice({
  name: "chat",
  initialState: initialCodeSliceObject,
  reducers: {
    updateMessage: (state, action: PayloadAction<any>) => {
      state.chatMessages = action.payload;
    },
    setAiResponding: (state, action: PayloadAction<boolean>) => {  // Match this name
      state.isAiResponding = action.payload;
    },
  },
});

export default chatSlice.reducer;
export const { updateMessage, setAiResponding} = chatSlice.actions;
